<template>
   <Teleport :to="modalRoot">
      <Transition name="fade">
         <div v-show="isOpen" @click="cancelClick" class="overlay-backdrop" style="position: fixed;inset: 0;background: rgba(0, 0, 0, 0.35);z-index: 1000;"></div>
      </Transition>
      <Transition name="fade">
        <div class="modal" ref="modalRef" :class="name + '-modal'" :id="name + '-modal'" tabindex="-1" role="dialog" @closed=modalHide v-show="isOpen" style="display:block;">
          <div class="modal-dialog" :class="modalSizeClass">
            <div class="modal-content" v-bind:style=" sgc ? 'text-align:center;overflow:hidden;' : '' ">
              <slot name="modal-header" v-if="sgc">
                <div class="modal-header" style="text-align:center;background-color:lightgray;">
                  <h2>
                    {{sgc}}
                  </h2>
                </div>
              </slot>
              <div class="modal-body">
                <slot></slot>
              </div>
              <div v-if="!disableOk || !disableCancel" class="modal-footer" v-bind:style=" sgc ? 'text-align:center;' : '' ">
                <slot name="modal-footer">
                  <button @click="cancelClick" class="btn btn-primary btn-nomargin" type="button" v-if="!disableCancel">
                    {{ cancelTitle }}
                  </button>
                  <slot name="extra-buttons"></slot>
                  <button :v-bind="tooltipAttrs" id="name + '-modal-btn'" ref="okBtn" @click="okClick" class="btn btn-primary btn-nomargin" type="button" v-show="!disableOk">
                    {{ okTitle }}
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </Transition>
   </Teleport>
</template>
<style>
   .fade-enter-active,
   .fade-leave-active {
     transition: opacity 0.2s ease;
   }

   .fade-enter-from,
   .fade-leave-to {
     opacity: 0;
   }
   .overlay-backdrop {
     position: fixed;
     inset: 0;
     background: rgba(0, 0, 0, 0.35);
     z-index: 1000;
   }
   .modal {
     position: fixed;
     inset: 0;
     z-index: 1010;
   }

</style>
<script>
  import { ref, computed, watch, inject, nextTick, onMounted, onBeforeMount} from 'vue'
  export default {
    name: "bootstrap-modal",
    props: {
      name:           { type: String   },
      okTooltip:      { default: ''    },
      okTitle:        { default: 'Ok'  },
      cancelTitle:    { default: 'Cancel' },
      sgc:            { default: ''  },
      disableOk:      { default: false },
      disableCancel:  { default: false, type: Boolean },
      largeModal:     { default: false, type: Boolean },
      smallModal:     { default: false, type: Boolean },
      value:          { type: Boolean  },
    },
    emits: ['ok', 'cancel'],
    setup(props, {emit}){
      const isOpen = ref(false)
      const modalRoot = inject('modalRoot')
      const modalSizeClass = computed(() => {
         if (props.largeModal)
          return 'modal-lg'
        else if (props.smallModal)
          return 'modal-sm'
        else
          return ''
      });
      const tooltipAttrs = computed(() => {
         if (props.okTooltip)
          return {
            title: props.okTooltip,
          }
        return {}
     
      });
      const cancelClick = ()  => {
        emit('cancel')
        modalHide()
      };
      const okClick = () => {
        emit('ok')
        modalHide()
      };
      const cleanupBootstrapModalArtifacts = () => {
         document.body.classList.remove('modal-open')
         document.querySelectorAll('.modal-backdrop').forEach(b => b.remove())
      };
      const modalShow = () => {
        isOpen.value = true
      };
      const modalHide = () => {
        isOpen.value = false
      };
      watch(() => props.value, () => {
        console.log("watch - bs_modal")
        if (props.value) {
          modalShow()
        } else {
          modalHide()
        }
     
      });

      watch(() => isOpen, () => {
        if (props.isOpen.value) {
        } else {
        }
      });
      onMounted(() => {
         isOpen.value = props.value
      });
      return {
         isOpen,
         modalRoot,
         modalHide,
         modalShow,
         cleanupBootstrapModalArtifacts,
         okClick,
         cancelClick,
         tooltipAttrs,
         modalSizeClass
      }
    }
  }
</script>
